// Social handles → canonical profile links. Agents enter a handle/ID; we build the
// correct URL per platform (patterns differ: LinkedIn needs /in/, YouTube/TikTok need
// @, Facebook vanity vs numeric, WeChat has no web URL). Also backward-compatible:
// if an older value is a full pasted URL, we extract the handle from it and rebuild.

export const SOCIALS = {
  instagram: { label: 'Instagram', icon: '📸', hint: 'yourhandle' },
  facebook:  { label: 'Facebook',  icon: '📘', hint: 'yourname or profile id' },
  linkedin:  { label: 'LinkedIn',  icon: '💼', hint: 'your-name' },
  youtube:   { label: 'YouTube',   icon: '▶️', hint: '@yourchannel' },
  tiktok:    { label: 'TikTok',    icon: '🎵', hint: '@yourhandle' },
  twitter:   { label: 'X',         icon: '✖️', hint: 'yourhandle' },
  wechat:    { label: 'WeChat',    icon: '💬', hint: 'your WeChat ID' },   // no web URL
};
export const SOCIAL_KEYS = Object.keys(SOCIALS);

const DOMAINS = {
  instagram: ['instagram.com'], facebook: ['facebook.com', 'fb.com'], linkedin: ['linkedin.com'],
  youtube: ['youtube.com', 'youtu.be'], tiktok: ['tiktok.com'], twitter: ['x.com', 'twitter.com'], wechat: [],
};

// Strip a pasted URL down to the bare handle/path (drops protocol, www, the platform
// domain, a leading @, query/hash, and surrounding slashes).
export function socialHandle(platform, raw) {
  let s = String(raw || '').trim();
  if (!s) return '';
  s = s.replace(/^https?:\/\//i, '').replace(/^www\./i, '');
  for (const d of (DOMAINS[platform] || [])) {
    if (s.toLowerCase().startsWith(d)) { s = s.slice(d.length); break; }
  }
  return s.replace(/[?#].*$/, '').replace(/^\/+/, '').replace(/\/+$/, '').replace(/^@/, '');
}

// Resolve a stored value to { icon, label, url, display, isLink }. url is null for
// WeChat (shown as a copyable ID). Returns null when empty/unknown.
export function socialLink(platform, raw) {
  const cfg = SOCIALS[platform];
  const h = socialHandle(platform, raw);
  if (!cfg || !h) return null;
  let url = null, display = cfg.label;
  switch (platform) {
    case 'instagram': url = `https://instagram.com/${h}`; display = `@${h}`; break;
    case 'twitter':   url = `https://x.com/${h}`; display = `@${h}`; break;
    case 'tiktok':    url = `https://tiktok.com/@${h}`; display = `@${h}`; break;
    case 'youtube':
      if (/^(channel|c|user)\//i.test(h)) url = `https://youtube.com/${h}`;
      else { url = `https://youtube.com/@${h}`; display = `@${h}`; }
      break;
    case 'facebook':
      url = /^\d+$/.test(h) ? `https://facebook.com/profile.php?id=${h}` : `https://facebook.com/${h}`;
      display = /^\d+$/.test(h) ? cfg.label : h;
      break;
    case 'linkedin':
      url = /^(in|company|pub|school)\//i.test(h) ? `https://linkedin.com/${h}` : `https://linkedin.com/in/${h}`;
      break;
    case 'wechat': url = null; display = h; break;   // no web profile — copyable ID
    default: return null;
  }
  return { platform, icon: cfg.icon, label: cfg.label, url, display, isLink: !!url };
}
